import { pipesRepository } from "@src/core/engine/pipes/pipesRepository";
import { TFunction } from "i18next";
import { BatchSelectionRow } from "../../../store/types";

export function getPipeSizeWarning(
  t: TFunction,
  row: BatchSelectionRow,
): string | null {
  if (!row.status || row.status.path !== "pipeSize") return null;
  const { sizeMax, sizeMin } = row.status.constraints;
  if (sizeMin === null && sizeMax === null) return null;

  return t(`status.pipeSize.${row.status.code}`, {
    interpolation: { escapeValue: false },
    sizeMax: pipesRepository.getValveSizeLabel(row.status.constraints.sizeMax),
    sizeMin: pipesRepository.getValveSizeLabel(row.status.constraints.sizeMin),
  });
}
